import { Interval } from '../lib/animation'
import easing from '../lib/easing'
import { createElement as $ } from '../lib/createElement'
import { offsetOfElement } from '../lib/helpers'
import { lerp } from '../lib/math'
import LazyImage from './LazyImage'

addEventListener('DOMContentLoaded', () => {
	const galleries = document.querySelectorAll('ui-image-gallery')
	for (let a = 0; a < galleries.length; a++) {
		new ImageGallery(galleries[a])
	}
})

export default class ImageGallery {
	currentSelected = null
	fullscreenMode = false
	images = []
	interval = null
	origin = {} // Parent element offsets.

	constructor(element, options = {}) {
		this.element = element

		this.images = [...this.element.querySelectorAll('ui-image-gallery-item')]
			.map((item) => {
				item.parentNode.removeChild(item)

				return {
					fullImage: item.dataset.imageFull || item.dataset.image,
					image: item.dataset.image,
					thumbnail: item.dataset.thumbnail || item.dataset.image,
				}
			})

		// Create elements.
		// Image preview.
		this.imagePreview = $('div', { className: 'preview' })
		this.element.appendChild(this.imagePreview)

		this.image = new LazyImage()
		this.imagePreview.appendChild(this.image)

		// Zoom button.
		this.zoomButton = $('a', {
			className: 'zoom-button',
			onClick: this.onZoomClick
		})
		this.element.appendChild(this.zoomButton)

		// Thumbnails.
		this.thumbnails = $('div', { className: 'thumbnails' })
		this.element.appendChild(this.thumbnails)
	
		if (this.images.length > 1) {
			for (let a = 0; a < this.images.length; a++) {
				const index = a
				const thumbnail = $('a', {
					className: 'thumbnail',
					onClick: () => this.onThumbnailClick(index),
					style: {
						backgroundImage: `url('${this.images[a].thumbnail}')`
					}
				})
				this.thumbnails.appendChild(thumbnail)
			}
		}

		// Prepare the fullscreen animation interval.
		this.interval = new Interval({
			autostart: false,
			duration: 700,
		}, this.animationTick)

		if (this.images.length > 0) {
			this.onThumbnailClick(0)
		}
	}

	onThumbnailClick = (index) => {
		for (let a = 0; a < this.thumbnails.childElementCount; a++) {
			if (a == index) {
				this.thumbnails.children[a].classList.add('selected')
			}
			else {
				this.thumbnails.children[a].classList.remove('selected')
			}
		}

		this.currentSelected = index

		const image = this.fullscreenMode ? this.images[index]?.fullImage : this.images[index]?.image
		const delay = this.interval.isRunning ? 0 : 400
		this.image.setImage(image, delay)
	}

	onZoomClick = () => {
		const parent = this.element.parentNode
		if (!parent || this.interval.isRunning) {
			return
		}

		this.fullscreenMode = !this.fullscreenMode

		// Decide where to animate from and to.
		const scrollX = window.scrollX || pageXOffset || document.body.scrollLeft
		const scrollY = window.scrollY || pageYOffset || document.body.scrollTop

		const parentOffsets = offsetOfElement(parent)
		this.origin = {
			x: parentOffsets.offsetLeft - scrollX,
			y: parentOffsets.offsetTop - scrollY,
			width: parent.offsetWidth,
			height: parent.offsetHeight,
		}

		this.interval.restart()
	}

	animationTick = (pos) => {
		if (this.fullscreenMode) {
			this.element.classList.add('fullscreen')
		}
		else {
			this.element.classList.add('closing')
		}

		const fullscreenOffsets = {
			x: 0,
			y: 0,
			width: innerWidth,
			height: innerHeight,
		}

		const from = this.fullscreenMode ? this.origin : fullscreenOffsets
		const to = this.fullscreenMode ? fullscreenOffsets : this.origin

		const ease = easing.calc(pos, easing.InOut, easing.Quint)
		this.element.style.left = lerp(from.x, to.x, ease) + 'px'
		this.element.style.top = lerp(from.y, to.y, ease) + 'px'
		this.element.style.width = lerp(from.width, to.width, ease) + 'px'
		this.element.style.height = lerp(from.height, to.height, ease) + 'px'

		if (pos == 1) {
			this.element.style.left = this.element.style.top = 
			this.element.style.width = this.element.style.height = null

			if (!this.fullscreenMode) {
				this.element.classList.remove('fullscreen', 'closing')
			}

			// Force reloading the either the low or high res image.
			this.onThumbnailClick(this.currentSelected)
		}
	}
}